import React from 'react'
import { I18nextProvider, initReactI18next } from 'react-i18next'
import i18next from 'i18next'
import LngDetector from 'i18next-browser-languagedetector'
import moment from 'moment'

import { supportedLanguages } from '@cbgms/base/translate/locales'
import { i18nInterpolationFormat } from '@cbgms/base/translate/i18nInterpolationFormat'
import Backend from 'utils-support/Backend'
import { useXDomain } from './XDomainContext'

export function I18nContextProvider({ children }: React.PropsWithChildren<{}>) {
  const xDomain = useXDomain()

  React.useEffect(() => {
    i18next
      .use(LngDetector)
      .use(Backend)
      .use(initReactI18next)
      .init({
        debug: __DEV__,
        interpolation: {
          escapeValue: false,
          format: i18nInterpolationFormat
        },
        fallbackLng: 'en-GB',
        parseMissingKeyHandler: key => key,
        detection: {
          caches: ['cookie', 'localStorage'],
          cookieOptions: {
            path: '/',
            sameSite: 'strict',
            secure: true,
            domain: xDomain
          },
          order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag', 'path', 'subdomain']
        },
        load: 'currentOnly',
        supportedLngs: __DEV__ ? undefined : supportedLanguages
      })

    i18next.on('languageChanged', (lng: string) => {
      moment.locale(lng)
    })
  }, [xDomain])

  return <I18nextProvider i18n={i18next}>{children}</I18nextProvider>
}

export { i18next }
